import type { Meta } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSLink, CMSLinkedImage } from '@swf/cms';

import styles from './CMSThumbnail.scss';

const CMSThumbnail: React.FC<Meta['thumbnail']> = (props) =>
  props.link.url ? (
    <div className={styles.thumbnail}>
      <CMSLinkedImage {...props} className={styles.thumbnailImage} />
      <CMSLink {...props.link} className={styles.thumbnailLink} />
    </div>
  ) : null;

export default CMSThumbnail;
